<template>
  <div>
    <Header />
    <div class="container bg-white mx-auto grid grid-flow-col auto-cols-auto gap-16 pb-8">
      <div class="text mx-auto">
        <p class="mx-8 hidden md:block crumb"><NuxtLink to="/">Home</NuxtLink></p>

        <h1>We're sorry, but the page cannot be located.</h1>

        <span>Please use the navigation above to find the page you're looking for.</span>
      </div>
    </div>
    <Footer />
  </div>
</template>

<style src="../assets/styles/global.css"></style>

<script setup lang="ts">
import { onMounted } from 'vue';
import { useNuxtApp } from '#app';

const { $userContext } = useNuxtApp();

onMounted(async () => {
  await $userContext.metaRefresh();
});
</script>

<style scoped>
.crumb {
  margin: 2rem 0 0;
}

h1 {
  font-size: 32px;
}
</style>
